import { useState } from "react";
import { useInView } from "react-intersection-observer";
import { useGetAllNoticesAsAdminQuery } from "../../../lib/apollo/graphql/generated";

function useNoticeList() {
  const { ref: fetchMoreRef } = useInView({
    threshold: 0.2,
    onChange: onEndReached,
  });

  const [fetchingMore, setFetchingMore] = useState(false);

  const [showNewRow, setShowNewRow] = useState(false);

  const { loading, data, fetchMore } = useGetAllNoticesAsAdminQuery({
    variables: {
      first: 10,
    },
  });

  function toggleShowNewRow(value: boolean) {
    setShowNewRow(value);
  }

  function onEndReached(inView: boolean) {
    if (
      inView &&
      !fetchingMore &&
      data?.getAllNoticesAsAdmin?.pageInfo?.hasNextPage
    ) {
      setFetchingMore(true);

      fetchMore({
        variables: {
          first: 20,
          after: data?.getAllNoticesAsAdmin?.pageInfo?.endCursor,
        },
      }).finally(() => {
        setFetchingMore(false);
      });
    }
  }
  return {
    refs: {
      fetchMoreRef,
    },
    models: {
      loading,
      data: data?.getAllNoticesAsAdmin?.edges,
      showNewRow,
    },
    operations: {
      toggleShowNewRow,
    },
  };
}

export default useNoticeList;
